
import { computed, defineComponent, ref } from "vue";
import { useStore } from "@/store";
import { LINE_COLORS } from "@/common/const";
import rfdc from "rfdc";
const clonedeep = rfdc();

import DiagramTrainTypeNecessaryTimeTable from "./DiagramTrainTypeNecessaryTimeTable.vue";
import DiagramTrainTypeManagerStopStationManager from "./DiagramTrainTypeManagerStopStationManager.vue";
import DiagramTrainTypeManagerNecessaryTimeManager from "./DiagramTrainTypeManagerNecessaryTimeManager.vue";

export default defineComponent({
  props: {
    trainTypeId: { type: Number, required: true },
  },
  components: {
    DiagramTrainTypeNecessaryTimeTable,
    DiagramTrainTypeManagerStopStationManager,
    DiagramTrainTypeManagerNecessaryTimeManager,
  },
  setup(props) {
    const store = useStore();

    const trainType = computed({
      get: () => store.getters.getTrainType(props.trainTypeId || 0),
      set: (value) => {
        if (!value) return;
        store.dispatch("updateTrainType", {
          id: props.trainTypeId,
          data: value,
        });
      },
    });
    const necessaryTimesA = computed({
      get: () => trainType.value?.necessaryTimesA,
      set: (value) => {
        if (!value) return;
        store.dispatch("updateTrainTypeNecessaryTimeTable", {
          trainTypeId: props.trainTypeId,
          boundFor: "A",
          newNecessaryTimeMap: value,
        });
      },
    });
    const necessaryTimesB = computed({
      get: () => trainType.value?.necessaryTimesB,
      set: (value) => {
        if (!value) return;
        store.dispatch("updateTrainTypeNecessaryTimeTable", {
          trainTypeId: props.trainTypeId,
          boundFor: "B",
          newNecessaryTimeMap: value,
        });
      },
    });

    const changeTrainId = (id: number) => {
      store.commit("setShowingTrainId", { id });
    };

    const lineColor = ref<string>(trainType.value?.lineColor || "");
    const typeName = ref<string>(trainType.value?.name || "");
    const changeLineColorAndTypeName = (e: {
      originalEvent: Event;
      value: string;
    }) => {
      if (!trainType.value) return;
      if (
        trainType.value.lineColor === e.value &&
        trainType.value.name === typeName.value
      )
        return;
      const newTrainType = clonedeep(trainType.value);
      newTrainType.lineColor = lineColor.value;
      newTrainType.name = typeName.value;

      store.dispatch("updateTrainType", {
        id: props.trainTypeId,
        data: newTrainType,
      });
    };

    const buttonColorStyle = computed(() => ({
      backgroundColor: lineColor.value,
      borderColor: lineColor.value,
    }));

    const isVisibleStopStationManagerModal = ref<boolean>(false);

    const addTrain = () => {
      if (!trainType.value) return;
      store.dispatch("addTrain", { trainTypeId: trainType.value.id });
    };
    const editStopStation = () => {
      isVisibleStopStationManagerModal.value = true;
    };

    const isVisibleMeasureNecessaryTimeDialog = ref(false);
    const measureNecessaryTime = () => {
      isVisibleMeasureNecessaryTimeDialog.value = true;
    };
    const deleteTrainType = () => {
      store.dispatch("deleteTrainType", { id: props.trainTypeId });
    };
    const splitButtonItems = ref([
      { label: "停車駅編集", icon: "pi pi-list", command: editStopStation },
      {
        label: "所要時間計測",
        icon: "pi pi-clock",
        command: measureNecessaryTime,
      },
      {
        label: "種別削除",
        icon: "pi pi-ban",
        command: deleteTrainType,
      },
    ]);
    return {
      trainType,
      lineColor,
      typeName,
      changeTrainId,
      changeLineColorAndTypeName,
      addTrain,
      LINE_COLORS,
      buttonColorStyle,
      necessaryTimesA,
      necessaryTimesB,
      splitButtonItems,
      isVisibleStopStationManagerModal,
      isVisibleMeasureNecessaryTimeDialog,
    };
  },
});
